export function TierBadge({
  name,
  color,
  glow = false,
  size = "sm",
}: {
  name: string;
  color?: string;
  glow?: boolean;
  size?: "sm" | "md";
}) {
  const style = color ? { color, borderColor: `${color}66`, backgroundColor: `${color}22` } : undefined;
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold uppercase tracking-wide ${
        size === "sm" ? "px-2 py-0.5 text-[9px]" : "px-2.5 py-1 text-[10px]"
      } ${glow ? "glow-brand" : ""}`}
      style={style}
    >
      {name}
    </span>
  );
}
